import script from "./CommercePromotionRules.vue?vue&type=script&setup=true&lang=js"
export * from "./CommercePromotionRules.vue?vue&type=script&setup=true&lang=js"

import "./CommercePromotionRules.vue?vue&type=style&index=0&id=2baa3251&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2baa3251"]])

export default __exports__